import React from "react";
import { imageUrlFor } from "../lib/image-url";
import { buildImageObj } from "../lib/helpers";

import * as styles from "../styles/components/featured-image.module.css";

const FeaturedImage = (props) => {

  const {
    desktop,
    mobile
  } = props;

  return (
    <div className={styles.root}>
      {desktop && desktop.asset && 
        <picture>
          <source media="(min-width:768px)" srcSet={imageUrlFor(buildImageObj(desktop)).auto("format").url()} />
          {mobile && mobile.asset && 
            <source media="(max-width:767px)" srcSet={imageUrlFor(buildImageObj(mobile)).auto("format").url()} />
          }
          <img src={imageUrlFor(buildImageObj(desktop)).auto("format").url()} alt={desktop.alt} />
        </picture>
      }
    </div>
  );
}

export default FeaturedImage;
